
import page from "~/layouts/blog.vue";

export default {
  components: {
    page,
  },

  head() {
    return {
      title:
        "Pourquoi faire appel à une agence de communication pour la création de votre site Internet ?",
      meta: [
        {
          hid: "description",
          name: "description",
          content:
            "À portée de doigt, en quelques clics, des solutions vous permettent désormais de réaliser des projets digitaux à l’instar d’un site Internet. Si autrefois des moyens importants étaient nécessaires, des solutions clé en main permettent dorénavant d’obtenir des résultats probants.",
        },
        {
          hid: "og:title",
          property: "og:title",
          content:
            "Pourquoi faire appel à une agence de communication pour la création de votre site Internet ?",
        },
        {
          hid: "og:description",
          property: "og:description",
          content:
            "À portée de doigt, en quelques clics, des solutions vous permettent désormais de réaliser des projets digitaux à l’instar d’un site Internet. Si autrefois des moyens importants étaient nécessaires, des solutions clé en main permettent dorénavant d’obtenir des résultats probants.",
        },
      ],
    };
  },
};
